import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = "We're sorry, something went wrong with our molecule processor";
  const description = "The issue has been reported and we'll investigate it as soon as possible.";
  const message = "We're sorry, something went wrong with our molecule processor.";

  return {
    title,
    description,
    message,
    toast: true,
    intent: Intent.DANGER,
    icon: 'error',
  };
}
